import { TAB_PCB_PARTS } from 'product_tabs/tabs/data/tabType';
import { openModal, updateShowBomSelection } from '../bomSlice';
import { selectDataForBomTabChange } from '../selector/selectors';

export const processTabChange = (tab) => async (dispatch, getState) => {
  const {
    available_bom_in_zip,
    bom_saved,
    bom_selected,
    changed_zip_file,
    uploaded_zip_file,
  } = selectDataForBomTabChange(getState());

  if(tab != TAB_PCB_PARTS) return;

  if(bom_saved && !changed_zip_file) return;

  if(uploaded_zip_file && available_bom_in_zip && !bom_selected) {
    dispatch(updateShowBomSelection(true))
    return;
  }

  if(bom_selected) dispatch(openModal())
}